var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.voltar()}}},[_c('v-icon',[_vm._v("mdi-arrow-left")]),_vm._v(" "+_vm._s(_vm.$t("Voltar"))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }